module.exports = __webpack_public_path__ + "static/media/logo2.1288fe0b.png";